import CtaButton from 'components/AnnouncementCampaigns/CtaButton'
import { clearActiveCampaign } from 'modules/campaigns/actions'
import { markAnnouncementPlaybookClicked } from 'modules/campaigns/announcements'
import { toggleChat } from 'modules/view/actions'
import React from 'react'
import { useDispatch } from 'react-redux'
import { CTAType } from 'types/message'

export default function DefaultCTA({ copy, type, url }) {
  const dispatch = useDispatch()

  const onCtaClicked = async () => {
    await markAnnouncementPlaybookClicked()
    dispatch(clearActiveCampaign())

    if (type === CTAType.LINK_TO_URL) {
      dispatch(toggleChat({ chatOpen: false }))
    }
  }

  return (
    <div className="drift-widget-greeting-cta-wrapper">
      <CtaButton
        ctaUrl={url}
        ctaType={type}
        ctaCopy={copy}
        onClick={onCtaClicked}
      />
    </div>
  )
}
